import {
    getDeviceIdByRadioId,
    getDeviceIdByVin,
} from '@sxm-de/dev-kits/web-sdk/domains/devices';
import { DomainInitPayload, Order } from '@sxm-de/dev-kits/web-sdk/types';
import { CreateOrderForNewSubscription } from '../helpers/create-order-for-new-subscription';

interface CreateOrderForAutomotiveFnPayload {
    offerId: string;
    promoCode?: string;
    deviceId?: string;
    radioId?: string;
    vin?: string;
    giftCardId?: string;
}

export type CreateOrderForAutomotiveFn = (
    payload: CreateOrderForAutomotiveFnPayload,
) => Promise<Order>;

export function initCreateOrderForAutomotiveFn({
    dependencies,
    state,
}: DomainInitPayload): CreateOrderForAutomotiveFn {
    return async ({
        offerId,
        promoCode,
        deviceId,
        radioId,
        vin,
        giftCardId,
    }) => {
        if (radioId) {
            deviceId = await getDeviceIdByRadioId({ radioId }, dependencies);
        }
        if (vin) {
            deviceId = await getDeviceIdByVin({ vin }, dependencies);
        }
        const { stripePaymentMethodId } = state;

        return await CreateOrderForNewSubscription(dependencies, {
            offerId,
            promoCode,
            deviceId,
            giftCardId,
            stripePaymentMethodId,
        });
    };
}
